import React, { useState, useEffect } from "react";
import API from "../../services/api";

const Barcode = () => {
    const [barcode, setBarcode] = useState("");
    const [product, setProduct] = useState(null);
    let scannedCode = ""; // Temporary storage for scanned characters
    let timeout; // Timeout to detect the end of a barcode scan

    useEffect(() => {
        const handleKeyPress = async (event) => {
            if (event.key === "Enter") {
                event.preventDefault();
                if (scannedCode) {
                    setBarcode(scannedCode);
                    fetchProduct(scannedCode);
                    scannedCode = ""; // Reset after scanning
                }
            } else {
                scannedCode += event.key;
                clearTimeout(timeout);

                // Wait for a short period to detect the end of the scan
                timeout = setTimeout(() => {
                    scannedCode = ""; // Reset if no further input
                }, 100);
            }
        };

        // Attach event listener to capture barcode input globally
        window.addEventListener("keydown", handleKeyPress);

        return () => {
            window.removeEventListener("keydown", handleKeyPress);
        };
    }, []);

    // Fetch product details based on barcode
    const fetchProduct = async (scannedBarcode) => {
        try {
            const response = await API.get(`/products/barcode/${scannedBarcode}`);
            setProduct(response.data);
        } catch (error) {
            console.error("Error fetching product:", error);
            setProduct(null);
        }
    };

    return (
        <div>
            <h2>Scanning Barcode...</h2>
            <h3>Latest Scanned Barcode: {barcode}</h3>

            {product ? (
                <div>
                    <h3>Product Details:</h3>
                    <p><strong>Name:</strong> {product.name}</p>
                    <p><strong>Category:</strong> {product.category_name}</p>
                    <p><strong>Brand:</strong> {product.brand}</p>
                    <p><strong>Country:</strong> {product.country}</p>
                    <p><strong>Price:</strong> ${product.price}</p>
                    <p><strong>Description:</strong> {product.description}</p>
                </div>
            ) : barcode && (
                <p>No product found for this barcode.</p>
            )}
        </div>
    );
};

export default Barcode;
